export default "__VITE_ASSET__f780b75e__"